
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#FEE2E2"}}),_c('g',{attrs:{"clip-path":"url(#clip0_16378_57157)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29 20a9 9 0 11-18 0 9 9 0 0118 0zm-7.875 4.5a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0zM20 14.375c-.621 0-1.125.504-1.125 1.125V20a1.125 1.125 0 002.25 0v-4.5c0-.621-.504-1.125-1.125-1.125z","fill":"#DC2626"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_16378_57157"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(10 10)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    